module.exports = "/_next/static/images/ourPartnersCharterLogo-8ef1fc1d1f9284d6736a552b93685456.webp";